import Button from "@components/common/button/Button";
import {Typography, withStyles} from '@material-ui/core';
import * as React from "react";
import TranslateNew from '@translate/TranslateNew';
import {WithStyles} from "@material-ui/core/styles";
import {CompletedStyles} from "@components/onboarding/steps/StepCompleted/completed.styles";
import ArrowForwardIcon from "@material-ui/icons/ArrowForward";
import DrakeDragon from "@components/svg/drakeDragom";

const tn: TranslateNew = TranslateNew.getInstance();

interface ICompletedProps extends WithStyles<typeof CompletedStyles> {
    nextStep: (customStep?: number) => void;
    classes: any;
}

class Completed extends React.Component<ICompletedProps> {

    constructor(props: ICompletedProps) {
        super(props);
    }

    

    public render() {

        const {classes: style} = this.props;

        return (
            <div className={style.root}>
                <div className={style.background}>
                    <DrakeDragon className={style.dragon}/>
                </div>
                <div className={style.container}>
                    <div className={style.middleContent}>
                        <Typography variant="h1">{tn.lang.onboardindCompletedTitle}</Typography>
                        <Typography>
                            {tn.lang.onboardindCompletedContent}
                        </Typography>
                    </div>
                    <Button
                        variant='contained'
                        color='primary'
                        size="large"
                        fullWidth={true}
                        onClick={() => this.props.nextStep()}>
                        <span style={{flex: 1}}>{tn.lang.onboardingCompletedButton}</span>
                        <ArrowForwardIcon fontSize="small"/>
                    </Button>
                </div>
            </div>
        );
    }
}

export default withStyles(CompletedStyles)(Completed);



// WEBPACK FOOTER //
// ./src/components/onboarding/steps/StepCompleted/completed.component.tsx